import styled from "@emotion/styled"

const MonoTitle = styled.h3`
    font-family: 'Andale Mono';
    font-size: 21px;
    font-weight: 300;
`

export default MonoTitle